export enum FlaggingReason {
  WrongCostCenter = 0,
  MissingProductOwner = 1,
  BudgetExceeded = 2,
  CostCenterOutdated = 3,
}

export interface FlaggingReasonDisplayInfo {
  title: string;
  message: string;
}

export const FlaggingReasonDisplayNames: Record<FlaggingReason, string> = {
  [FlaggingReason.WrongCostCenter]: "Wrong Cost Center",
  [FlaggingReason.MissingProductOwner]: "Missing Product Owner",
  [FlaggingReason.BudgetExceeded]: "Budget Exceeded",
  [FlaggingReason.CostCenterOutdated]: "Cost Center Outdated",
};

export const FlaggingReasonDisplayInfo: Record<FlaggingReason, FlaggingReasonDisplayInfo> = {
  [FlaggingReason.WrongCostCenter]: {
    title: "Invalid cost center.",
    message: "To continue using the requested service, please provide a valid charging code. If you are unsure which code to use, contact your Financial Controller for assistance.",
  },
  [FlaggingReason.MissingProductOwner]: {
    title: "No Product Owner Assigned.",
    message: "To keep your project active, a Product Owner must be assigned. Please contact your Scrum Master, or if your project has no Scrum Master, contact DevTech Support.",
  },
  [FlaggingReason.BudgetExceeded]: {
    title: "Budget limit exceeded for this charging code.",
    message: "To continue using the requested tools, either increase the budget for the provided charging code with your Financial Controller or select a different cost code with available budget.",
  },
  [FlaggingReason.CostCenterOutdated]: {
    title: "Outdated cost center.",
    message: "To continue using the requested service, please provide a valid charging code. If you are unsure which code to use, contact your Financial Controller for assistance.",
  },
};